import {Button, Card, Form, Select, Spin, Upload} from 'antd';
import React from "react";
import {getFormFieldByType} from "../../util/methods";
import EquipmentSubTypeSubList from "../../components/EquipmentSubTypeSubList";
import DocumentList from "../../components/DocumentList";
import {LoadingOutlined, PlusOutlined} from "@ant-design/icons";

class Create extends React.Component {
  state = {
    value: '',
    checklist: [],
    documentData: [],
    uploadFile: true,
    count: 1,
    fileList: [],
    file: null,
    loading: false,
    showUploadList: false,
  };

  componentDidMount() {
    const {match, fetch} = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }
  }

  getDocumentData = (data) => {
    this.setState({ documentData: data });
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.data && this.props && this.props.data && JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)) {
      this.setState({checkList: nextProps.data.checklist});
    }
  }

  componentWillUnmount() {
    this.props.refreshData();
  }

  handleSubmit = (e) => {
    const {match} = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }
      const { documentData } = this.state;
      const data = Object.assign({}, values);
      // data.documents = documentData;
      if (documentData.length === 0) {
        data.documents = this.props && this.props.data && this.props.data.documents;
      } else {
        data.documents = documentData ;
      }

      if (!data.checklist) {
        data.checklist = [];
      }
      if (!data.service) {
        data.service = [];
      }

      if (match.params && match.params.id) {
        this.props.onSubmit(data, match.params.id);
      } else {
        this.props.onSubmit(data);
      }
    });
  };

  getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  customUpload = file => {
    this.setState(state => ({
      fileList: [file],
      file: file,
      showUploadList: true,
    }));
    return false;
  };

  handleChangeForImage = async info => {
    let fileList = [...info.fileList];
    fileList = fileList.slice(-1);
    this.setState({ fileList });
    if (info.file) {
      await this.getBase64(info.file, imageUrl =>
        this.setState({
          imageUrl,
          loading: false,
        })
      );
    }
  };

  handleSearch = value => {
    this.props.fetchEquipmentSubType(value, 'EquipmentSubType', 'name');
  };

  handleChange = value => {
    const { equipmentSubType } = this.props;
    const copyEquipmentSubType = equipmentSubType.find(item => item._id === value);
    this.setState({ checkList: copyEquipmentSubType.checklist, value });
  };

  render() {
    const {getFieldDecorator} = this.props.form;
    const {data, loading, filters, title, resource, form, equipmentSubType, subDocumentFilters} = this.props;
    const { imageUrl } = this.state;
    const {checkList} = this.state;
    const uploadButton = (
      <div>
        {this.state.loading ? <LoadingOutlined /> : <PlusOutlined />}
        <div className="ant-upload-text">Upload</div>
      </div>
    );
    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`}>
          <Form onSubmit={this.handleSubmit} layout="vertical">

            {Object.keys(filters).map((item) => {
              if (filters[item].type === 'Array' && filters[item].schema) {
                if (item === 'checklist') {
                  return <EquipmentSubTypeSubList title={title} resource={resource} key={item} item={filters[item]} form={form} data={checkList || []}/>
                }
                return <EquipmentSubTypeSubList title={title} resource={resource} key={item} item={filters[item]} form={form} data={data[item] || []}/>
              } else {
                if (item === 'documents') {
                  return <DocumentList match={this.props.match} history={this.props.history} key={item} item={filters[item]} form={form} data={data[item]} subDocumentFilters={subDocumentFilters} getDocumentData={this.getDocumentData}/>
                }
                return getFormFieldByType(filters, item, getFieldDecorator, data, {resource})
              }
            })}

            <div >
              <label>Search Asset Sub Type to Copy CheckList</label>
              <Select
                showSearch
                value={this.state.value}
                placeholder={'Search Asset Sub Type'}
                defaultActiveFirstOption={false}
                showArrow={false}
                filterOption={false}
                onSearch={this.handleSearch}
                onChange={this.handleChange}
                notFoundContent={null}
                style={{width: '100%', marginBottom: '20px', display: 'block'}}
              >
                {equipmentSubType.map(item => {
                  return <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>
                })}
              </Select>
            </div>

            <Form.Item key={'files'} label="Upload Icon">
              {getFieldDecorator('files', {
                rules: [{required: false }],
                initialValue: (data && data['file']) ? data['file'] : []
                //initialValue: (data && data['icon']) ? data['icon'] : []
              })(
                <Upload
                  listType="picture-card"
                  className="avatar-uploader"
                  name="files"
                  onChange={this.handleChangeForImage}
                  showUploadList={false}
                  beforeUpload={this.customUpload}
                  fileList={this.state.fileList}
                >
                  {imageUrl || data && data.icon ? <img src={imageUrl || data.icon} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
                </Upload>
              )}
            </Form.Item>

            <Form.Item>
              <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading}>
                {this.props.title === 'EDIT' ? 'UPDATE' : 'CREATE'}
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
